// extracted by mini-css-extract-plugin
export default {"table":"egXLLxB6fV3Fs0SsRQ7d","product-table":"dXfWnWcSILTWsXCI5QA3"};